<!-- 弹框dialog -->
<template>
  <el-dialog
    v-loading="loading"
    :title="config.dialogConfig.title"
    :width="config.dialogConfig.width"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :popper-append-to-body="true"
    @close="dialogHandle('close')"
    class="config-dialog"
  >
    <div class="dialog-body">
      <!-- 表单 -->
      <el-form
        :model="dialogForm"
        :ref="refName"
        :label-position="config.formConfig.labelPosition"
        :label-width="config.formConfig.labelWidth"
      >
        <!-- 内容 -->
        <template v-for="(item, index) in config.query">
          <el-form-item :label="item.label" :prop="item.key" :key="index" :rules="item.rules">
            <component
              :is="item.comp"
              v-model.trim="dialogForm[item.key]"
              :placeholder="item.placeholder"
              :rules="item.rules"
              :style="item.style"
              :maxlength="item.maxlength"
              :show-word-limit="item.showWordLimit"
              clearable
            ></component>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <!-- 按钮 -->
    <div slot="footer" class="dialog-footer" v-if="config.btn">
      <template v-for="(item, index) in config.btn">
        <component
          :key="index"
          :is="item.comp"
          :type="item.type"
          @click="dialogHandle(item)"
          style="width: 120px"
        >
          {{ item.label }}
        </component>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import * as configAll from './config.js';
export default {
  name: 'ConfigDialog',
  components: {},
  props: {
    // 配置项名称
    configName: {
      type: String,
      default: '',
    },
    // 盒子状态
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogForm: {},
      refName: 'dialogRef',
      config: {},
      loading: false,
    };
  },
  computed: {},
  created() {
    const val = this.configName;
    if (val && configAll[val]) {
      const temp = { ...configAll[val] };
      // 遍历配置项的model
      const key = {};
      temp.query.forEach((_) => {
        key[_.key] = '';
      });
      this.dialogForm = { ...key };
      this.config = temp;
    }
  },
  mounted() {},
  methods: {
    // 盒子事件
    dialogHandle(e) {
      if (e.btnQuery === 'saveClose') {
        this.$refs[this.refName].validate((valid) => {
          if (valid) {
            this.loading = true;
            const { dialogForm } = this;
            this.config
              .api({
                ...dialogForm,
              })
              .then((res) => {
                this.closeDialog();
                this.$message.success(`${e.label}成功`);
                // 保存成功回调, 如刷新表格
                this.$emit('dialogEmit', res);
                this.loading = false;
              })
              .catch((error) => {
                this.$message.error(error.message);
                this.loading = false;
              });
          } else {
            return false;
          }
        });
      } else {
        this.closeDialog();
      }
    },
    // 关闭弹窗 重置数据
    closeDialog() {
      this.$emit('update:dialogVisible', false);
      this.$refs[this.refName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
